// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"0a71db43","229":"83ab201c","601":"8ca680ed"}[chunkId] + ".chunk.css";
};